import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import DomainsTableItem from './DomainsTableItem/DomainsTableItem';

import './DomainsTable.scss';

const b = block('domains-table-desktop');

const DomainsTable = ({ domainRequests, agentDomains, requestType, openModal, totalCount }) => {
  const locale = useSelector(state => state.locale.locale);

  const domainRequestsType = requestType === 'my-requests';

  if (totalCount === 0 || (!domainRequestsType && domainRequests.length === 0)) {
    return <div className={b('empty')}>{domainRequestsType ? locale.noDomainsAssigned : locale.noRequests}</div>;
  }

  return (
    <div className={b({ 'agent-domains': !domainRequestsType })}>
      <div className={b('header')}>
        <div className={b('header-title')}>{requestType === 'my-requests' ? locale.myDomains : locale.requests}</div>
        <div className={b('header-count')}>
          {requestType === 'my-requests' ? locale.totalDomains : locale.totalRequests}:{' '}
          {requestType === 'my-requests' ? totalCount : domainRequests.length}
        </div>
      </div>
      <div className={b('table-header', { 'agent-domains': !domainRequestsType })}>
        {domainRequestsType ? (
          <>
            <div className={b('table-header-domain')}>{locale.domain}</div>
            <div className={b('table-header-date')}>{locale.date}</div>
          </>
        ) : (
          <>
            <div className={b('table-header-domain')}>{locale.domainRequested}</div>
            <div className={b('table-header-date')}>{locale.date}</div>
            <div className={b('table-header-comment')}>{locale.comment}</div>
            <div className={b('table-header-status')}>{locale.status}</div>
          </>
        )}
      </div>
      {domainRequestsType ? (
        <div className={b('content')}>
          {agentDomains.map(agentDomain => (
            <DomainsTableItem key={agentDomain.id} data={agentDomain} />
          ))}
        </div>
      ) : (
        <div className={b('content')}>
          {domainRequests.map(agentDomain => (
            <DomainsTableItem key={agentDomain.id} data={agentDomain} openModal={openModal} />
          ))}
        </div>
      )}
    </div>
  );
};

export default DomainsTable;
